import { render, staticRenderFns } from "./capture.vue?vue&type=template&id=1152dcbc"
import script from "./capture.ts?vue&type=script&lang=js&external"
export * from "./capture.ts?vue&type=script&lang=js&external"
import style0 from "./capture.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports